import type { SVGProps } from 'react'

export interface ChevronIconProps extends SVGProps<SVGSVGElement> {
  direction?: 'up' | 'down' | 'left' | 'right'
}

export function ChevronIcon({ direction = 'down', style, ...props }: ChevronIconProps) {
  const rotation = {
    up: 180,
    down: 0,
    left: 90,
    right: -90,
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      style={{ transform: `rotate(${rotation[direction]}deg)`, ...style }}
      {...props}
    >
      <path
        d="M1 1L6 5L11 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
